import React, { useState } from 'react';
import DayPicker from 'react-day-picker';

import { DayPickerHotelWrap } from './TrainFormStyles';
import { getDate } from 'UtilityComponents/Util';
import { SHORTLIST_SHARE_CONSTANTS } from 'AppConstants';
import { TrainIcon } from '../../Style';
import { FlexDiv, GenericDiv } from 'commonStyles';

function TrainCalender({ handleChange, isMobile }) {
	const [selectedDay, setSelectedDay] = useState(new Date());
	const [showCalender, setShowCalender] = useState(false);
	const today = new Date();
	const disabledDays = { before: today };

	const handleDayClick = (day) => {
		setSelectedDay(day);
		setShowCalender(!showCalender);
		handleChange(day);
	};

	const formattedDate = getDate(selectedDay, SHORTLIST_SHARE_CONSTANTS.LATO_DATE);

	const trainFormContainerProps = isMobile ? {
		bdr: '1px solid rgb(204, 204, 204)',
		bdrRad: '4px',
		bottom_P: 10,
		top_P: 10,
		left_P: 8,
		right_P: 8
	} : {};

	return (
		<GenericDiv {...trainFormContainerProps}>
			<FlexDiv
				align='center'
				justify='space-between'
				height={isMobile ? '30px' : ''}
				onClick={() => setShowCalender(!showCalender)}>
				<p dangerouslySetInnerHTML={{ __html: formattedDate }} />
				<TrainIcon icon='icDownArrow' />
			</FlexDiv>
			{showCalender &&
				<DayPickerHotelWrap isMobile>
					<DayPicker
						selectedDays={selectedDay}
						onDayClick={handleDayClick}
						fromMonth={new Date()}
						numberOfMonths={2}
						initialMonth={selectedDay}
						disabledDays={disabledDays}
					/>
				</DayPickerHotelWrap>}
		</GenericDiv>
	);
}

export default TrainCalender;
